module.exports = __webpack_public_path__ + "static/proverka-9b0179424d73e0b1d9560deea3282f22.png";